import axios from 'axios'
import authService from './authService';
import { auth } from '../firebase';
import { generateTokenTmp } from '../controllers/userController';

// Cria uma função que retorna os headers atualizados
function getAuthHeaders() {
  // console.log('Origem com token autenticado');
  return {
    Authorization: authService.getToken(),
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': 'http://localhost:3000',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
  }
}

// Origem com token autenticado
export const apiGate = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: getAuthHeaders(),
  withCredentials: false
});


// Origem com token temporário
export const apiGate2 = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: generateTokenTmp(),
    'Content-Type': 'application/json',
  },
  withCredentials: false
})

// Atualiza os headers quando o token for atualizado
window.addEventListener('tokenUpdated', () => {
  apiGate.defaults.headers.common['Authorization'] = authService.getToken();
});

export const apiChatBot = axios.create({
  baseURL: process.env.REACT_APP_API_CHATBOT,
  headers: {
    Authorization: process.env.REACT_APP_GATE_KEY,
    'Content-Type': 'application/json',
  },
  withCredentials: false
})



// export const apiStreamGate = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   headers: {
//     Authorization: process.env.REACT_APP_GATE_KEY,
//     'Content-Type': 'application/json',
//   },
//   withCredentials: true,
//   responseType: 'stream'
// })

// Interceptor global para lidar com erros CORS e autorização
const setupInterceptors = (instance) => {
  instance.interceptors.request.use(
    config => {
      // Atualiza o token de autorização antes de cada requisição 
      // (apenas para apiGate que usa token dinâmico)
      if (instance === apiGate) {
        config.headers.Authorization = authService.getToken();
      }
      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.message.includes('Network Error') || error.message.includes('CORS')) {
        // console.error('Problema de CORS detectado:', error);
      }
      // Se receber erro 401 (não autorizado), tenta atualizar o token
      if (error.response && error.response.status === 401) {
        console.error('Token expirado ou inválido. Tentando atualizar o token...', auth);
        if (auth.currentUser) {
          // Se o usuário estiver autenticado, tenta atualizar o token
          auth.currentUser.getIdToken(true).then((token) => {
            authService.setToken(token);
            error.config.headers.Authorization = token;
            return axios.request(error.config);
          }).catch((error) => {
            authService.clearToken();
            // Redirecionar para a página de login
            window.location.href = '/login'
          });
        } else {
          // Se o usuário não estiver autenticado, limpa o token e redireciona para a página de login
          authService.clearToken();
          window.location.href = '/login'
        }
        //   auth.currentUser.getIdToken().then((token) => {
        //     authService.setToken(token);
        //   }).catch((error) => {
        //     authService.clearToken();
        //     // Redirecionar para a página de login
        //     window.location.href = '/login'
        //   });
      }
      return Promise.reject(error);
    }
  );
};

// Aplicar interceptors as instâncias 
[apiGate].forEach(setupInterceptors);